module.exports = __webpack_public_path__ + "static/media/meteringicon02.8fcb6093.png";